module.exports = __webpack_public_path__ + "static/tesla-powerwall-1080w-e65fa132ed6070fe42073811c6edbf80.jpg";